<script>
export default {
    props: {
        buttonClass: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'button',
        },
        icon: {
            type: String,
            default: '',
        },
        toolTipText: {
            type: String,
            default: '',
        },
    },
}
</script>

<template>
    <b-button
        v-b-tooltip.hover
        :disabled="disabled"
        :variant="variant"
        :class="buttonClass"
        :title="toolTipText"
        @click="$emit('click', $event)"
    >
        <div class="mgb-button__wrapper">
            <svgicon v-if="icon" :class="`${buttonClass}__icon`" :icon="icon" />
            <span>
                <slot></slot>
            </span>
        </div>
    </b-button>
</template>

<style lang="scss" scoped>
@import '~@src/design/components/buttons.scss';
</style>
